import React                from 'react';
import { pitch }            from 'pu-data/SelectOptions';
import { pitch as tooltip } from 'pu-data/Tooltips';
import SelectComponent      from './SelectComponent';

const Pitch = (props) => {
  const name = 'pitch';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <SelectComponent
      label={props.label}
      required={props.required}
      name={name}
      onChange={onChange}
      options={props.options}
      tooltip={props.tooltip}
      selected={props.parameters[name]}
      groupName={props.groupName} />
  );
};

Pitch.defaultProps = {
  options: pitch,
  label  : 'Min.<br class="d-none d-lg-block" /> Pitch',
  tooltip,
};

export default Pitch;
